module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/example-background-d4d292686f54663651136efc1389ddf9.png";